import { render, staticRenderFns } from "./TourMark.vue?vue&type=template&id=6447018d&scoped=true"
import script from "./TourMark.vue?vue&type=script&lang=js"
export * from "./TourMark.vue?vue&type=script&lang=js"
import style0 from "./TourMark.vue?vue&type=style&index=0&id=6447018d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447018d",
  null
  
)

export default component.exports